import { Badge, Column, Row, Typography } from '@/components'
import { ComponentColors, ThemeColor } from '@/enums'
import { ArrowRight } from '@/icons'
import { paths } from '@/routes/paths'
import { Address } from '@/types/address'
import { YearlyCheckInStatus } from '@/types/assessment'
import { makeAddress, useGoToPath } from '@/utils'
import { useOutletContext } from 'react-router-dom'
import { DashboardCompanyCardItem, LocationCardContent } from './styles'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface LocationCardProps {
  name: string
  locationId: string
  address: Address
  yearlyCheckInStatus: YearlyCheckInStatus
  isHeadquarters: boolean
}

export const LocationCard: FC<LocationCardProps> = ({
  name,
  locationId,
  address,
  yearlyCheckInStatus,
  isHeadquarters,
}: LocationCardProps) => {
  const { t } = useTranslation()
  const goToLocation = useGoToPath(paths.viewLocationWithKey(locationId))
  const { cart } = useOutletContext<{
    cart: Record<string, string[]>
  }>()

  const isPendingYearlyCheck = yearlyCheckInStatus === 'pending'

  return (
    <DashboardCompanyCardItem
      onClick={() => goToLocation()}
      isHeadquarters={isHeadquarters}
    >
      <LocationCardContent>
        <Column gap="4px">
          {isHeadquarters && (
            <Row alignItems="center" gap="8px">
              <Typography variant="footnote" color={ThemeColor.info1}>
                {t('headquarter')}
              </Typography>
            </Row>
          )}
          <Row alignItems="center" gap="8px">
            <Typography bold variant="p1Body" textAlign="left">
              {name}
            </Typography>
            <Badge
              color={ComponentColors.danger}
              count={
                (cart[locationId]?.length || 0) + (isPendingYearlyCheck ? 1 : 0)
              }
            />
            <ArrowRight size="message" />
          </Row>
          <Typography
            color={ThemeColor.b50}
            variant="badgeText"
            textAlign="left"
          >
            {makeAddress(address)}
          </Typography>
        </Column>
      </LocationCardContent>
    </DashboardCompanyCardItem>
  )
}
